import { SalesReportSummary } from "../../../types/sale-reports.type";
import { numberWithCommas } from "../../../utils";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

interface TripDataCardProps {
  reportSummary: SalesReportSummary;
}

interface InfoRowProps {
  label: string;
  value: React.ReactNode;
  valueColor?: "gray" | "primary";
}

const InfoRow = ({ label, value, valueColor = "gray" }: InfoRowProps) => (
  <Box mb={0.75}>
    <Typography
      variant="caption"
      fontWeight={600}
      sx={{ display: "block", whiteSpace: "nowrap", lineHeight: 1.3 }}
    >
      {label}
    </Typography>
    <Typography
      variant="caption"
      {...(valueColor === "primary"
        ? { color: "primary", fontWeight: 600 }
        : {})}
      sx={{
        display: "block",
        whiteSpace: "nowrap",
        lineHeight: 1.3,
        ...(valueColor === "gray"
          ? { color: (theme) => theme.palette.gray.main }
          : {}),
      }}
    >
      {value}
    </Typography>
  </Box>
);

export default function TripDataCard({ reportSummary }: TripDataCardProps) {
  return (
    <Card
      sx={{
        border: (theme) => `1px solid ${theme.palette.primary.main}`,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        boxShadow: "none",
        borderRadius: "12px",
      }}
    >
      <CardContent
        sx={{ padding: 0, width: "100%", "&:last-child": { padding: 0 } }}
      >
        <Box display="flex" alignItems="center" gap={0.5}>
          <DeleteOutlineOutlinedIcon
            color="primary"
            sx={{ fontSize: "16px" }}
          />
          <Typography variant="caption" color="primary" fontWeight={700}>
            ภาพรวมของเสีย
          </Typography>
        </Box>
        <Box display="flex" mt={0.5}>
          <Box flex={1} minWidth={0}>
            <InfoRow
              label="รวมยอดเบิก"
              value={`${numberWithCommas(reportSummary.brought_count_total)} ชิ้น`}
            />
            <InfoRow
              label="ของเหลือ"
              value={`${numberWithCommas(reportSummary.leftover_count_total)} ชิ้น`}
            />
            <InfoRow
              label="ของเสีย"
              value={`${numberWithCommas(reportSummary.waste_count_total)} ชิ้น`}
            />
          </Box>
          <Box
            sx={{
              width: "1px",
              mx: 2,
              flexShrink: 0,
              background: `repeating-linear-gradient(
                to bottom,
                transparent 0,
                transparent 3px,
                #AEAEAE 3px,
                #AEAEAE 6px
              )`,
            }}
          />
          <Box flex={1} minWidth={0}>
            <InfoRow
              label="น้ำหนักของเสีย"
              value={`${reportSummary.waste_weigh} kg`}
              valueColor="primary"
            />
            <InfoRow
              label="%ของเสีย"
              value={`${reportSummary.waste_percent_total}%`}
            />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
